const SORT_LS_DATA = {
  diamonds: {
    col: 'end_time',
    asc: true,
  },
  jewelry: {
    col: 'end_time',
    asc: true,
  },
  watches: {
    col: 'end_time',
    asc: true,
  },
};

const HAMPTON_SORT_LS_DATA: HamptonTypes.Sort = {
  field: 'lotNumber',
  order: 'asc',
};

const defaultViewPreferences: BuyerTypes.BuyerViewPreferences = {
  diamonds: 'plain',
  jewelry: 'thumbnails',
  watches: 'thumbnails',
  following: 'plain',
  in_prog: 'plain',
  won: 'plain',
  didnt_win: 'plain',
  all: 'plain',
};

type LsBuyersDataType = {
  sort: typeof SORT_LS_DATA;
  hamptonSort: HamptonTypes.Sort;
  viewPreferences: BuyerTypes.BuyerViewPreferences;
};

const defaultLsData: LsBuyersDataType = {
  sort: SORT_LS_DATA,
  hamptonSort: HAMPTON_SORT_LS_DATA,
  viewPreferences: defaultViewPreferences,
};

export function setLsPortalData(data: LsBuyersDataType) {
  localStorage.setItem('portal', JSON.stringify(data));
}

export function getLsPortalData() {
  const portalStorageData = localStorage.getItem('portal');

  const lsData = portalStorageData && (JSON.parse(portalStorageData) as LsBuyersDataType);

  if (!lsData) {
    setLsPortalData(defaultLsData);
  }

  return { ...defaultLsData, ...lsData };
}

export function getLocalStorageSort(): AuctionsTypes.AuctionsSortType {
  const portalStorageData = getLsPortalData();
  const lsSort = portalStorageData?.sort;
  const sort = lsSort ? { ...SORT_LS_DATA, ...lsSort } : SORT_LS_DATA;

  return sort;
}

export function setLocalStorageSort(
  type: AuctionsTypes.AuctionTypes,
  value: { col: string; asc: boolean },
) {
  const data = getLsPortalData();

  data.sort = {
    ...data.sort,
    [type]: value,
  };

  setLsPortalData(data);
}

export function getLsViewPreferences(): BuyerTypes.BuyerViewPreferences {
  const portalData = getLsPortalData();

  return portalData.viewPreferences;
}

export function setLsViewPreferences(preferences: Partial<BuyerTypes.BuyerViewPreferences>) {
  const lsData = getLsPortalData();

  setLsPortalData({
    ...lsData,
    viewPreferences: {
      ...lsData.viewPreferences,
      ...preferences,
    },
  });
}

export function getHamptonSort(): HamptonTypes.Sort {
  const portalStorageData = getLsPortalData();
  const lsSort = portalStorageData?.hamptonSort;

  return lsSort ? { ...HAMPTON_SORT_LS_DATA, ...lsSort } : HAMPTON_SORT_LS_DATA;
}

export function setHamptonSort(value: HamptonTypes.Sort) {
  const data = getLsPortalData();

  data.hamptonSort = value;

  setLsPortalData(data);
}
